import { render, staticRenderFns } from "./apply-flow.vue?vue&type=template&id=64116650&scoped=true"
import script from "./apply-flow.vue?vue&type=script&lang=ts"
export * from "./apply-flow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64116650",
  null
  
)

export default component.exports